import React, { useState } from 'react';
import { Modal, Form, Input, InputNumber, Button, message } from 'antd'; // Import Button and InputNumber
import emailjs from '@emailjs/browser';
import SuccessModal from './SuccessModal';

const ApplicationFormModal = ({ open, onClose, courseName, programName }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState({ open: false, message: '' });

  const handleSubmit = (values) => {
    setLoading(true);
    const templateParams = {
      ...values,
      program_path: programName,
      // --- MODIFIED: Send the level name to the `selected_level` variable ---
      selected_level: courseName, 
    };

    // Replace with your actual credentials
    const serviceID = 'service_sb61i9y';
    const templateID = 'template_cpu576s';
    const publicKey = '_MAPT6u2x17ZgW8Tf';

    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then(() => {
        setSuccessModal({ open: true, message: 'Application sent! We will contact you back for confirmation.' });
        onClose(); // Close the form modal
        form.resetFields(); // Clear the form for the next time
      }, (error) => {
        message.error('Submission failed. Please try again later.');
        console.error('EmailJS Error:', error.text);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose}
        title={`Apply for: ${programName}`}
        footer={null}
        destroyOnClose // Ensures the form is reset when closed
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit} autoComplete="off">
          
          {/* --- The Course Title (read-only) --- */}
          <Form.Item label="Selected Level">
            <Input value={courseName} disabled />
          </Form.Item>

          {/* --- Applicant Information Fields --- */}
          <Form.Item 
            name="full_name" 
            label="Full Name" 
            rules={[{ required: true, message: 'Please enter your full name!' }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item 
            name="age" 
            label="Age" 
            rules={[{ required: true, message: 'Please enter your age!' }]}
          >
            <InputNumber size="large" min={16} style={{ width: '100%' }} />
          </Form.Item>
          
          <Form.Item 
            name="phone_number" 
            label="Phone Number" 
            rules={[{ required: true, message: 'Please enter your phone number!' }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item 
            name="email_address" 
            label="Email Address" 
            rules={[{ required: true, type: 'email', message: 'Please enter a valid email!' }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item 
            name="city" 
            label="City" 
            rules={[{ required: true, message: 'Please enter your city!' }]}
          >
            <Input size="large" />
          </Form.Item>
          
          {/* You can add the "Motivation" fields here as well if needed */}
          {/* 
          <Form.Item name="training_reason" label="Reason for Training">
             ...
          </Form.Item>
          */}

          <Form.Item>
            {/* Using an Ant Design button for consistent styling */}
             <Button type="primary" htmlType="submit" loading={loading} block size="large">
              {loading ? 'Submitting...' : 'Submit Application'}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <SuccessModal
        open={successModal.open}
        message={successModal.message}
        onClose={() => setSuccessModal({ open: false, message: '' })}
      />
    </>
  );
};

export default ApplicationFormModal;